import { useTranslation } from 'react-i18next';

import { Box, Typography, Button } from '@mui/material';

import { stylesErrorTitle, stylesErrorContent } from '@/utils/globalStyles';

export function UnderConstructionFallback() {
  const { t } = useTranslation('components');
  return (
    <Box role='alert' sx={{ textAlign: 'center' }}>
      <Box component='h1' sx={stylesErrorTitle}>
        {t('underConstructionFallback.title')}
      </Box>
      <Typography variant='bodyXL' component='p' sx={stylesErrorContent}>
        {t('underConstructionFallback.content')}
      </Typography>
      <Button href='/folders'>{t('errorFallback.folders')}</Button>
    </Box>
  );
}
